/** Surface / button / status backgrounds — accept solid or gradient. */
export const FILL_TOKEN_KEYS = [
    "background",
    "backgroundAccent",
    "headerBackground",
    "footerBackground",
    "btnTrackBg",
    "btnTrackBgHover",
    "btnShopBg",
    "btnShopBgHover",
    "statusBgActive",
    "statusBgInactive",
];

/** Body / heading / description / status labels — solid color + optional clip fill. */
export const TEXT_TOKEN_KEYS = [
    "textColor",
    "textDescription",
    "textColorMuted",
    "headingText",
    "textDiscount",
    "statusColorActive",
    "statusColorInactive",
    "footerTextColor",
];
